/**
 * Face Search ↔ Transfers — banner for the PUBLIC transfer download page.
 *
 *   <FindMyPhotosBanner transferRef={shareToken} />
 *
 * Renders nothing unless a face-search gallery exists for this transfer.
 */
import React, { useEffect, useState } from "react";
import { ScanFace, ArrowRight } from "lucide-react";
import { facePublic } from "../lib/faceApi";

export default function FindMyPhotosBanner({ transferRef, className = "" }) {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    let alive = true;
    if (!transferRef) return undefined;
    facePublic.forTransfer(transferRef).then((d) => alive && setInfo(d)).catch(() => alive && setInfo(null));
    return () => { alive = false; };
  }, [transferRef]);
  if (!info) return null;
  const ready = info.photos_indexed > 0;
  return (
    <a href={info.public_url} className={`flex items-center gap-3 rounded-2xl border border-amber-400/30 bg-amber-400/10 p-4 text-white transition hover:bg-amber-400/15 ${className}`}>
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber-400 text-black"><ScanFace className="h-6 w-6" /></span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold">Find your photos with a selfie</span>
        <span className="block text-xs text-white/70">{ready ? `Take a selfie and instantly see every photo you're in (${info.photos_indexed.toLocaleString("en-IN")} photos ready).` : "Take a selfie to find every photo you're in — photos appear as they are uploaded."}</span>
      </span>
      <ArrowRight className="h-5 w-5 shrink-0 text-amber-300" />
    </a>
  );
}
